import { render } from "./SystemStatus.vue?vue&type=template&id=2b6cf0fd"
import script from "./SystemStatus.vue?vue&type=script&lang=js"
export * from "./SystemStatus.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__